export type SoilDetails = {
  totalSoilAmount: number; // 全土量
  remainingSoilAmount: number; // 残土量
  actualSoilAmount: number; // 実績土量
  progressRate: number; // 進捗率
  actualStartDate: string; //実績開始日
  estimatedCompleteDate: string; // 予測完了日
  delayDays: number; // 遅れ (遅れている日数)
};

export type TotalSoil = {
  total: SoilDetails; // 合計
  cutSoil: SoilDetails; // 切土
  fillSoil: SoilDetails; // 盛土
};

export type ScheduleDetailTask = TotalSoil & {
  id: number;
  hasAsBuilt: boolean;
  status: TaskStatus;
  name: string;
  //以下2つの設計データは変換済み
  designDataId?: number;
  designDataName?: string;
  nextTaskId?: number;
  beforeTaskId?: number;
  scheduledStartDate: string;
  scheduledEndDate: string;
  completeDate?: string;
};

export type ScheduleDetailConstructionZone = TotalSoil & {
  id: number;
  name: string;
  scheduledStartDate: string;
  scheduledEndDate: string;
  status: TaskStatus;
  completeDate?: string;
  tasks: ScheduleDetailTask[];
};

export type Schedules = TotalSoil & {
  id: number;
  name: string;
  scheduledStartDate: string;
  scheduledEndDate: string;
  //status: TaskStatus;
  constructionZones: ScheduleDetailConstructionZone[];
  holidays?: string[];
  /* 土量計算進行状態 */
  isDoneSoilAmountCalculation: boolean;
};

export enum TaskStatus {
  /** 未開始 */
  NOT_STARTED = 'NOT_STARTED',
  /** 進行中 */
  IN_PROGRESS = 'IN_PROGRESS',
  /** 完了 */
  COMPLETED = 'COMPLETED',
}

type Column = { span: number; isOpen: boolean };

export type ColumnStates = {
  redisplay: Column;
  task: Column;
  unit: Column;
  quantity: Column;
  machine: Column;
  note: Column;
  progress: Column;
};

export enum ScheduleSize {
  MIN = 'MIN',
  MAX = 'MAX',
  MIDDLE = 'MIDDLE',
}
